module.exports = __webpack_public_path__ + "static/media/18_portrait.0b425120.jpg";